import constants from '@/constants'
import { createMicroserviceClient } from './microservice'

const baseURL = constants().payrollServer

export default createMicroserviceClient(baseURL)
